/**
 * VelocityIndicator - displays a velocity score with directional arrow.
 */
import React from 'react';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';

interface Props {
  velocity: number;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  className?: string;
}

const VelocityIndicator: React.FC<Props> = ({
  velocity,
  size = 'md',
  showLabel = true,
  className = '',
}) => {
  const v = Number(velocity || 0);
  const isUp = v > 5;
  const isDown = v < -5;
  const Icon = isUp ? ArrowUp : isDown ? ArrowDown : Minus;
  const color = isUp
    ? 'text-green-600'
    : isDown
    ? 'text-red-600'
    : 'text-gray-500';

  const sizeClasses =
    size === 'lg'
      ? 'text-2xl'
      : size === 'sm'
      ? 'text-xs'
      : 'text-sm';
  const iconSize = size === 'lg' ? 'w-5 h-5' : size === 'sm' ? 'w-3 h-3' : 'w-4 h-4';

  const formatted = v > 0 ? `+${v.toFixed(1)}` : v.toFixed(1);

  return (
    <span
      className={`inline-flex items-center gap-1 font-medium ${color} ${sizeClasses} ${className}`}
      title={`Velocity score: ${formatted}`}
    >
      <Icon className={iconSize} />
      {showLabel && <span>{formatted}</span>}
    </span>
  );
};

export default VelocityIndicator;
